/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { GetStudenteRicaricheView } from './getStudenteRicaricheView';
import { PageableObject } from './pageableObject';
import { SortObject } from './sortObject';

export interface PageGetStudenteRicaricheView { 
    totalPages?: number;
    totalElements?: number;
    pageable?: PageableObject;
    first?: boolean;
    last?: boolean;
    numberOfElements?: number;
    size?: number;
    content?: Array<GetStudenteRicaricheView>;
    number?: number;
    sort?: SortObject;
    empty?: boolean;
}